import StoreIcon from 'icons/shop/store-icon.svg';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Notify, Icon } from 'react-vant';
import useAreaCookie from 'hooks/useAreaCookie';
import { addShopCollect, cancelShopCollect } from 'api/shop';

export type ShopCategoryItem = {
  title: string;
  id: string;
  showMore?: boolean;
  children?: Array<ShopCategoryItem>;
};

export type ShopInfo = {
  sysNo: string;
  supplierSysNo: string;
  supplierName: string;
  name: string;
  mainBusiness: string;
  serviceHotline: string;
  serviceHours: string;
  shopCollectFlag: boolean;
  mallCategoryTreeDTO: {
    categories: Array<ShopCategoryItem>;
  };
  score: string | number;
};

export default function ShopInfoHead({
  name,
  supplierSysNo,
  sysNo,
  shopCollectFlag,
  supplierName,
}: ShopInfo) {
  const router = useRouter();
  const { getCookieAreaCode } = useAreaCookie();
  const [collectFlag, setCollectedFlag] = useState(shopCollectFlag);

  function handleProfile() {
    router.push(`/shop/profile/${sysNo}?id=${supplierSysNo}`);
  }

  async function collectedShop() {
    if (collectFlag) {
      const res = await cancelShopCollect({ productShopSysNo: sysNo });
      if (res?.code === 200) {
        Notify.show({ type: 'success', message: '已取消店铺收藏！' });
        setCollectedFlag(false);
      }
    } else {
      const res = await addShopCollect({
        productShopSysNo: sysNo,
        productShopName: name,
        supplierSysNo,
        supplierName,
        areaCode: getCookieAreaCode(),
      });
      if (res?.code === 200) {
        Notify.show({ type: 'success', message: '收藏店铺成功！' });
        setCollectedFlag(true);
      }
    }
  }

  return (
    <div className="shop-info">
      <div className="shop-info-left">
        <div className="shop-info-icon">
          <StoreIcon />
        </div>
        <span className="shop-info-name">{name}</span>
        <div className={collectFlag ? 'collected' : 'dis-collected'} onClick={collectedShop}>
          <Icon name="star-o" className="star" />
          <span className="text">{collectFlag ? '已收藏' : '收藏'}</span>
        </div>
      </div>

      <div className="shop-info-right" onClick={handleProfile}>
        档案
      </div>
      <style jsx>{`
        .shop-info {
          padding: 5px 18px 8px 16px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          background-color: #fff;
        }
        .shop-info-left {
          display: flex;
          align-items: flex-start;
          flex: 1;
        }
        .shop-info-name {
          font-size: 17px;
          color: #333333;
          margin-left: 8px;
          font-weight: bold;
        }

        .shop-info-icon {
          flex: 0 0 16px;
          height: 16px;
          margin-top: 5px;
        }
        .shop-info-right {
          border: 0.8px solid var(--primaryColor);
          border-radius: 9px;
          width: 38px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: var(--primaryColor);
          flex: 0 0 38px;
          margin-top: 5px;
        }
        .text {
          margin-left: 5px;
        }
        .dis-collected {
          background-color: red;
          color: #fff;
          padding : 2px 10px;
          border-radius: 15px;
          margin: 0px 5px;
          min-width: 70px;
        }
        .collected {
          background-color: #f2f2f2;
          padding : 2px 10px;
          border-radius: 15px;
          margin: 0px 5px;
          min-width: 82px;
        }
      `}</style>
    </div>
  );
}
